module.exports = __webpack_public_path__ + "img/icon_job_01.8aa66bf5.svg";